'use strict';

exports.__esModule = true;
exports.getValueFromHtmlTag = getValueFromHtmlTag;

var _isEmpty = require('../../utils/is-empty');

var _TagSchemas = require('../../types/TagSchemas');

var _identify = require('../../renderer/utils/identify');

var _parse = require('../../renderer/utils/parse');

var _getByIdentifier = require('./get-by-identifier');

function getValueFromHtmlTag(htmlString, identifier) {
  if (!htmlString || !_TagSchemas.TAG_SCHEMAS[identifier]) {
    return null;
  }

  var tags = (0, _parse.parse)(htmlString);
  var isTagValid = tags.length === 1 && !(0, _isEmpty.isEmpty)(tags[0]) && (0, _identify.identify)(tags[0]) === identifier;

  return isTagValid ? (0, _getByIdentifier.getValueByIdentifier)(tags, identifier) : null;
}